//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapActions, mapState, mapMutations } from 'vuex'
    import Loader from './components/loader'
    
    export default {
        name: "CommunitiesListing",
        components: {
            Loader
        },
        data() {
            return {
                api: this.$root.api,
                searchFilters: [],
                currentQuery: '',
                indexName: this.$root.indexName,
            }
        },
        computed: {
            ...mapState({
                isLoading: state => state.isLoading,
                isIntialized: state => state.isIntialized,
                isError: state => state.isError,
                filters: state => state.filters,
                communities: state => state.communities,
                currentPage: state => state.currentPage,
                totalPages: state => state.totalPages,
                currentFilters: state => state.currentFilters,
                searchQuery: state => state.searchQuery,
                validQuery: state => state.validQuery,
                currentFilterImage: state => state.filterImage,
                currentTypes: state => state.currentTypes,
                currentLocations: state => state.currentLocations,
                headerText: state => state.headerText,
                searchFieldWatermark: state => state.searchFieldWatermark,
            }),
            payload() {
                let page = this.currentPage
                let query = this.searchQuery
                let location = ''
                let type = this.currentFilters
                return { page, query, location, type }
            },
            clearActive(){
                let contentSelected = this.currentQuery != '' || this.currentTypes.length > 0 || this.currentLocations.length > 0 ? true : false
                return contentSelected
            }
        },
        methods: {
            ...mapActions(['getData', 'setFilters', 'setQuery']),
            ...mapMutations(['setCurrentFilters', 'setCurrentPage', 'setApi', 'setIndexName', 'setFilterImage', 'setHeaderText', 'setSearchFieldWatermark', 'clearCurrentFilters',]),
    
            async clearSearch() {
                var checkboxes = document.querySelectorAll('input[type="checkbox"]');
                for (var checkbox of checkboxes) {
                    checkbox.checked = this.checked;
                }
                this.currentQuery = ''
                this.clearCurrentFilters()
    
                let page = 1
                let query = ''
                let location = ''
                let type = []
                let cleanPayload = { page, query, location, type }
                this.setApi(this.$root.api)
    
                await this.getData(cleanPayload)
            }
        },
        watch: {
        },
        async created() {
            this.setApi(this.$root.api)
            this.setIndexName(this.$root.indexName)
    
            this.setFilterImage(this.$root.filterImage)
            this.setHeaderText(this.$root.headerText)
            this.setSearchFieldWatermark(this.$root.searchFieldWatermark)
            await this.getData(this.payload)
            this.searchFilters = this.filters
    
        }
    }
    